import { FC } from "react";
import { IBanner } from "../../../types/common";
import { observer } from "mobx-react-lite";
import { isMobile } from "react-device-detect";
import { Button } from "@headlessui/react";
import { useNavigate } from "react-router";
import { title } from "process";

const Banner = ({ banner }: { banner: IBanner }) => {
  const navigate = useNavigate();

  return (
    <div
      className={
        !isMobile
          ? "w-full bg-[#383181] rounded-[20px] p-[30px] flex flex-col gap-[20px]"
          : "flex flex-col p-[20px] gap-[15px] w-full bg-[#383181] rounded-[20px]"
      }
    >
      {banner.title && (
      <span className="text-white text-left  text-[20px] md:text-[27px] tracking-[-2%]" style={{
        fontWeight: '550',
        lineHeight: isMobile ? '120%': '100%' 
      }}>{banner.title}</span>
      )}
      {banner.description && (
      <span className="text-white font-semibold text-left text-[14px] md:text-[20px] tracking-[-2%] leading-[100%]">
        {banner.description}
      </span>
      )}

      {banner.link && (
        <Button
          className={
            "!bg-white !text-[#232323] rounded-[20px]  !cursor-pointer " +
            (isMobile ? " w-[70%]" : "w-[15%]")
          }
          onClick={() => window.open(banner.link)}
        >
          {banner.link_text || "Перейти"}
        </Button>
      )}
    </div>
  );
};

export default observer(Banner);
